module.exports = __webpack_public_path__ + "static/media/provider5@2x.1bd82eb0.png";